var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout"},[_c('Header'),_c('div',{staticClass:"d-flex"},[_c('notifications'),_c('Menu',{staticClass:"d-none d-lg-block"}),_c('router-view',{staticClass:"content-view"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }